import Vue from "vue";
import VueRouter from "vue-router";
import home from "../views/home"
import serve from "../views/serve"
import success from "../views/success"
import contact from "../views/contact"
import witstar from "../views/witstar"
import brandOverseas from "../views/brandOverseas"

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "home",
        component: home
    },
    {
        path: "/home",
        name: "home",
        component: home
    },
    {
        path: "/serve",
        name: "serve",
        component:serve
    },
    {
        path: "/success",
        name: "success",
        component:success
    },
    {
        path: "/contact",
        name: "contact",
        component:contact
    },
    {
        path: "/witstar",
        name: "witstar",
        component:witstar
    },
    {
        path: "/brandOverseas",
        name: "brandOverseas",
        component: brandOverseas
    },
];

const router = new VueRouter({
    routes,
    scrollBehavior () {
        return { y: 0 }
    }
});

export default router;
